<template>
	<div>
		<div class="margin-bottom-sm" v-for="(number, index) in cfg.number" :key="index">
			<el-input
				v-model="values[index]"
				:placeholder="cfg.placeholder"
				:clearable="cfg.clearable"
				:show-word-limit="cfg.showWordLimit"
				:maxlength="cfg.maxlength ? cfg.maxlength : false"
				:minlength="cfg.minlength ? cfg.minlength : false"
				:style="{ width: cfg.width }"
				@change="changeInput"
			></el-input>
			<el-button type="infor" class="margin-left-sm" @click="deleteInputArrayItem(index)">
				<i class="el-icon-delete"></i>
				删除
			</el-button>
		</div>
		<el-button type="primary" @click="addInputArrayItem">
			<i class="el-icon-plus"></i>
			添加
		</el-button>
		<span class="margin-left-sm"> {{cfg.number}} / {{cfg.max}}</span>
	</div>
</template>

<script>
export default {
	name: 'form-item-input-array',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: Array,
			default: () => {
				return [];
			}
		},
		config: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			cfg: {},
			values: []
		};
	},
	beforecreate: function() {},
	created: function() {},
	mounted() {
		this.values = this.value;
		this.cfg = this.config;
		if(this.values.length>this.cfg.number) this.cfg.number=this.values.length;
		if(this.values.length<this.cfg.number){
			for(let i=this.values.length;i<this.cfg.number;i++){
				this.values.push('');
			}
		}
	},
	updated: function() {},
	methods: {
		changeInput(e) {
			this.$emit('change', this.values);
		},
		deleteInputArrayItem(index) {
			if(this.cfg.number<=this.cfg.min){
				this.$message.error("至少要有["+this.cfg.min+"]个输入框");
				return false;
			}
			this.cfg.number--;
			this.values.splice(index,1);
			this.$emit('change', this.values);
		},
		addInputArrayItem() {
			if(this.cfg.number>=this.cfg.max){
				this.$message.error("最多["+this.cfg.max+"]个输入框");
				return false;
			}
			this.cfg.number++;
			this.values.push('');
			this.$emit('change', this.values);
		}
	},
	watch: {
		config: function(val) {
			this.cfg = val;
		}
	}
};
</script>

<style></style>
